import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import i18nextHTTPMiddleware from 'i18next-http-middleware';
import { languageDirection, processLanguageResources } from 'src/utils/i18n';
import * as resources from 'src/i18n/resources';
import config from 'src/config/i18n.json';

const languageResources = processLanguageResources(resources);

const languageDetector =
	typeof window === 'undefined' ? new i18nextHTTPMiddleware.LanguageDetector() : new LanguageDetector();

languageDetector.addDetector({
	name: 'custom',
	lookup() {
		return config.defaultLanguage;
	},
});

void i18n
	.use(languageDetector)
	.use(initReactI18next)
	.init({
		resources: languageResources,
		fallbackLng: config.defaultLanguage,
		supportedLngs: config.languageKeys,
		defaultNS: 'common',
		preload: config.languageKeys,
		detection: {
			order: ['path', 'custom'],
			lookupFromPathIndex: 0,
		},
	} as any);

function setHTMLLanguage(language) {
	if (typeof window !== 'undefined') {
		document.documentElement.setAttribute('lang', language);
		document.documentElement.setAttribute('dir', languageDirection(language));
		document.body.setAttribute('dir', languageDirection(language));
	}
}

i18n.on('languageChanged', setHTMLLanguage);
setHTMLLanguage(i18n.language);

export default i18n;
